export const ValidationErrorMessages = {
  ERRORS: {
    SERVER_CONNECTION_PROBLEM: "SERVER_CONNECTION_PROBLEM.",
    NETWORK_CONNECTION_PROBLEM: "NETWORK_CONNECTION_PROBLEM.",
    FIELD_REQUIRED: "This field is required.",
    MOBILE_VALIDATION_ERROR: "Check your phonenumber.",
    LOGIN_ERROR: "Invalid username or password",
    PASSWORD_AND_CONFIRM_PASSWORD_BE_THE_SAME: "Password and confirm password not match",
    CHANGE_PASSWORD: "Check your password",
    TRY_AGAIN: "Something gone wrong, please try again",
    EMAIL_FORMAT_NOT_VALID: "Email address format is not valid",
    MONTHLY_RENT_SMALLER_THAN_HOT: "Monthly rent is smaller than after discount",
  },
  SUCCESS: {
    FORGET_PASSWORD_SMS_SENT: "New Password Has Been Sent To Your Mobile.",
    CHANGE_PASSWORD: "Your Password Has Been Changed.",
    AGENT_ADDED: "Agent Successfully Added.",
    AGENT_Edited: "Agent Successfully Edited.",
    REGION_ADDED: "Region Successfully Added.",
    REGION_EDITED: "Region Successfully Edited.",
    NEW_ITEM_ADDED: "Item Successfully Added.",
    NEW_ITEM_EDITED: "Item Successfully Edited.",
    ITEM_STATUS_UPDATED: "Item Status Updated.",
    REGION_SORT_EDITED: "Region Sort Changed.",
    IMAGE_UPLOADED_SUCCESSFULLY: "Image Uploaded Successfully.",
    REQUEST_DELETED_SUCCESSFULLY: "Request Deleted Successfully.",
    ABOUT_US_EDITED_SUCCESSFULLY: "About Us Updated Successfully.",
  }
};
